import styled from "styled-components";
import { Tooltip } from "antd";

export const TooltipContainer = styled(Tooltip)`
  position: relative;
  left: 10px;
  display: inline-block;
  cursor: pointer;
`;

export const TooltipContainerButton = styled(Tooltip)`
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: 100%;
`;

export const TooltipCircle = styled.img`
  width: 15px;
  height: 15px;
  vertical-align: middle;
`;

export const HeaderTooltip = styled(Tooltip)``;
